import styled from 'styled-components';

export const Tag = styled.button`
  background: ${(props) => props.color};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 10px;
  border: none;
  border-radius: 6px;
  vertical-align: middle;
  letter-spacing: 1px;
  color: #fff;
  border-radius: 3px;
  padding: 1px 6px;
  cursor: initial;
`;
